import React, { useContext } from 'react';
import {
  Box,
  Button,
  Flex,
  Icon,
  Menu,
  MenuButton,
  MenuList,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { MdNotifications, MdOpenInNew, MdWarningAmber } from 'react-icons/md';
import { AuthContext } from 'contexts/AuthContext';

export default function StripeSetupReminder() {
  const {
    stripeSetupRequired,
    stripeSetupLoading,
    stripeSetupLinkLoading,
    openStripeSetup,
  } = useContext(AuthContext) || {};

  const navbarIcon = useColorModeValue('gray.400', 'white');
  const menuBg = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const secondaryText = useColorModeValue('gray.700', 'gray.400');
  const hoverBg = useColorModeValue('gray.50', 'whiteAlpha.100');

  if (!stripeSetupRequired) return null;

  return (
    <Menu closeOnSelect={false}>
      <MenuButton
        as={Button}
        aria-label="Stripe setup required"
        variant="ghost"
        me="10px"
        p="0"
        minW="40px"
        h="40px"
        borderRadius="12px"
        isLoading={stripeSetupLoading}
      >
        <Box id="nav-alerts" position="relative" display="inline-block">
          <Icon as={MdNotifications} color={navbarIcon} w="20px" h="20px" />
          <Box
            position="absolute"
            top="-2px"
            right="-2px"
            bg="red.500"
            borderRadius="full"
            w="8px"
            h="8px"
          />
        </Box>
      </MenuButton>
      <MenuList
        boxShadow="14px 17px 40px 4px rgba(112, 144, 176, 0.18)"
        p="16px"
        borderRadius="20px"
        bg={menuBg}
        border="none"
        maxW="350px"
        minW="300px"
      >
        <Flex mb="12px" align="center" justify="space-between">
          <Text fontSize="md" fontWeight="700" color={textColor}>
            Stripe Setup
          </Text>
          <Box
            bg="orange.100"
            color="orange.600"
            fontSize="xs"
            fontWeight="700"
            borderRadius="full"
            px="8px"
            py="2px"
          >
            pending
          </Box>
        </Flex>
        <Text fontSize="xs" color={secondaryText} mb="16px">
          Claiming new classes requires active payouts and charges.
        </Text>
        <Flex
          p="12px"
          borderRadius="8px"
          bg="transparent"
          _hover={{ bg: hoverBg }}
          align="flex-start"
          mb="12px"
        >
          <Flex
            align="flex-start"
            justify="center"
            flexShrink={0}
            mt="2px"
            me="10px"
          >
            <Icon as={MdWarningAmber} color="orange.500" w="16px" h="16px" />
          </Flex>
          <Flex direction="column" flex={1}>
            <Text fontSize="sm" fontWeight="600" color={textColor} noOfLines={1}>
              You need to setup Stripe
            </Text>
            <Text fontSize="xs" color={secondaryText} noOfLines={2} mt="2px">
              Open Stripe in a separate tab, finish the steps, and return here.
            </Text>
          </Flex>
        </Flex>
        <Button
          w="100%"
          colorScheme="orange"
          size="sm"
          rightIcon={<Icon as={MdOpenInNew} />}
          isLoading={stripeSetupLinkLoading}
          onClick={openStripeSetup}
        >
          Open Stripe Setup
        </Button>
      </MenuList>
    </Menu>
  );
}
